import React from "react";
import { Col, Input, Row } from "antd";
import {
  CircleCheckIcon,
  CircleIcon,
  ErrorFillIcon,
  ErrorUnfillIcon,
  MicIcon,
} from "../Icons";

const { TextArea } = Input;

const LegislationTab = () => {
  const handleInputChange = () => {};
  return (
    <>
      <div className="headings">
        <h2>NDIS Service Agreement Form</h2>
        <p>
          This agreement is made between the participant and the service
          provider under the National Disability Insurance Scheme (NDIS).
        </p>
      </div>
      <div className="formContainer">
        <div className="formLeft formBox">
          <div className="formLeftHeader">
            <div className="count">
              <p>1</p>
            </div>
            <div className="labels">
              <p>Placeholder</p>
              <p>Placeholder</p>
            </div>
          </div>
          <div className="formLeftRadio">
            <CheckRow status="active" />
            <CheckRow status="active" />
            <CheckRow status="error" />
          </div>
        </div>
        <div className="formRight formBox">
          <div className="top">
            <span></span>
            <h2>Partecipant Details</h2>
          </div>
          <div className="bottom">
            <Row gutter={[24, 24]}>
              <Col xs={24} md={8}>
                <div className="inputRow">
                  <label>Label</label>
                  <Input
                    error
                    placeholder="Placeholder"
                    onChange={(e) => handleInputChange(e, "active")}
                    style={{ border: "2px solid var(--green)" }}
                  />
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div className="inputRow">
                  <label>Label</label>
                  <Input
                    placeholder="Placeholder"
                    style={{ border: "2px solid var(--green)" }}
                  />
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div className="inputRow">
                  <label>Label</label>
                  <Input
                    placeholder="Placeholder"
                    style={{ border: "2px solid #FE7A95" }}
                  />
                  <div className="errorText">
                    <span>
                      <ErrorUnfillIcon />
                    </span>
                    <p>Error message goes here</p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <div className="formContainer">
        <div className="formLeft formBox">
          <div className="formLeftHeader">
            <div className="count">
              <p>1</p>
            </div>
            <div className="labels">
              <p>Placeholder</p>
              <p>Placeholder</p>
            </div>
          </div>
          <div className="formLeftRadio">
            <CheckRow status="inactive" />
            <CheckRow status="inactive" />
            <CheckRow status="inactive" />
          </div>
        </div>
        <div className="formRight formBox">
          <div className="top">
            <span></span>
            <h2>Partecipant Details</h2>
          </div>
          <div className="bottom">
            <div className="inputRow">
              <label>Label</label>
              <TextArea
                placeholder="Type your message..."
                autoSize={{ maxRows: 5 }}
                suffix={"dd"}
              />
              <span className="inputIcon">
                <MicIcon />
              </span>
            </div>
          </div>
          <div className="bottom">
            <div className="inputRow">
              <label>Label</label>
              <TextArea
                placeholder="Type your message..."
                autoSize={{ maxRows: 5 }}
                suffix={"dd"}
              />
              <span className="inputIcon">
                <MicIcon />
              </span>
            </div>
          </div>
          <div className="bottom">
            <Row gutter={[24, 24]}>
              <Col xs={24} md={8}>
                <div className="inputRow">
                  <label>Label</label>
                  <Input placeholder="Placeholder" />
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div className="inputRow">
                  <label>Label</label>
                  <Input placeholder="Placeholder" />
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div className="inputRow">
                  <label>Label</label>
                  <Input placeholder="Placeholder" />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

const CheckRow = ({ status }) => {
  return (
    <div className="flrRow">
      {status === "active" ? (
        <CircleCheckIcon />
      ) : status === "error" ? (
        <ErrorFillIcon color="#525558" />
      ) : (
        <CircleIcon color="#525558" />
      )}
      <p>Placeholder is required</p>
    </div>
  );
};

export default LegislationTab;
